import { Skeleton } from '@/components/ui/Skeleton.tsx';

export const MobileRecordCardSkeleton = () => (
  <li className="flex flex-col gap-2 border-b border-neutral-100 px-1 py-3">
    <Skeleton className="h-[18px] w-[55%]" />
    <Skeleton className="h-[14px] w-[70%]" />
    <Skeleton className="h-[14px] w-[40%]" />
  </li>
);

const MobileRecordListSkeleton = ({ count = 5 }: { count?: number }) => (
  <ul className="flex flex-col">
    {Array.from({ length: count }, (_, index) => (
      <MobileRecordCardSkeleton key={index} />
    ))}
  </ul>
);

export default MobileRecordListSkeleton;
